import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface IKeyPersonnelProfilesProps {
  heading: string;
  info: string;
  isLast: boolean;
}

export const WorkInfoRow: React.FC<IKeyPersonnelProfilesProps> = ({ heading, info, isLast }) => {
  const styles = StyleSheet.create({
    workInfoRow: {
      display: 'flex',
      flexDirection: 'row',
      borderTop: '0.5px dotted #77787C',
      borderBottom: isLast ? '0.5px dotted #77787C' : 'none',
      padding: '3px 0 3px 0',
      width: '348px',
      minHeight: '20px',
    },
    workInfoHeading: {
      fontFamily: 'Noto',
      fontWeight: 600,
      fontSize: '8px',
      lineHeight: 1.33,
      color: '#000',
      width: '93px',
      minHeight: '20px',
    },
    workInfoText: {
      fontWeight: 300,
      fontSize: '9px',
      lineHeight: 1.33,
      width: '255px',
      maxHeight: 200,
    },
  });
  return (
    <View style={styles.workInfoRow}>
      <Text style={styles.workInfoHeading}>{heading}</Text>
      <Text style={[styles.workInfoHeading, styles.workInfoText]}>{info}</Text>
    </View>
  );
};
